import {WalletContext} from '#/contexts/wallet-provider';
import {useContext} from 'react';
import {useConfig} from 'wagmi';

export const useIsConnectedToTargetChain = () => {
  const {
    accountResult: {chain},
  } = useContext(WalletContext);
  const {chains} = useConfig();

  return chain?.id !== undefined && chain.id === chains[0]?.id;
};
